import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Container, Price, Label } from './priceSummary.styles';
import messages from './priceSummary.messages';

export class PriceSummary extends PureComponent {
  static propTypes = {
    price: PropTypes.number,
  };

  render() {
    return (
      <Container>
        <Label>
          <FormattedMessage {...messages.label} />
        </Label>
        <Price>${this.props.price}</Price>
      </Container>
    );
  }
}
